import styles from "./home.module.css";

import { useHomeQuery } from "../../../queries/useHomeQuery";

import {
  Collections,
  FeaturedBanner,
  PromotionalBanner,
  Testimonial,
  Blogs,
  ServiceFeatures,
  HandWearCollection,
} from "../../../components/index.js";

import {
  Products,
  ThumbnailSlider,
} from "../../../components/web-app/index";

import { useState, useEffect } from "react";

import { useGetWishLists } from "../../../queries/useWishListQuery.js";

import BrandSlider from "../../../components/Brands/Brands.jsx";

import ProductPopup from "../../../components/web-app/PopupProduct/PopupProduct.jsx";

import HomeImagePopup from "../../../components/ImagepopUp/Imagepopup.jsx";
import Recommendations from "../../../components/Recommendation/Recommendation.jsx";

const Home = () => {
  const { data } = useHomeQuery();

  const [showPopup, setShowPopup] =
    useState(false);

  const {
    banners = [],
    categories = [],
    top_offers = [],
    new_arrivals = [],
    trending_products = [],
    sections = [],
   
  } = data || {};

  const {
    data: wishItems = [],
    isPending,
  } = useGetWishLists();

  // ==================================================
  // NORMALIZE HOME PRODUCT
  // ==================================================

  const normalizeProduct = (product) => {
    const activeVariant =
      Array.isArray(product?.variants)
        ? product.variants.find(
            (variant) =>
              variant?.status !== false
          )
        : null;

    // HOME API PRICE
    const price = Number(
      activeVariant?.price ??
        product?.price ??
        0
    );

    // HOME API OFFER PRICE
    const offer_price = Number(
      activeVariant?.offer_price ??
        product?.offer_price ??
        0
    );

    // HOME API QUANTITY
    const qty = Array.isArray(
      product?.variants
    )
      ? product.variants.reduce(
          (total, variant) =>
            total +
            Number(
              variant?.quantity || 0
            ),
          0
        )
      : Number(
          product?.qty || 0
        );

    // HOME API SKU
    const sku =
      activeVariant?.sku ||
      product?.sku ||
      "";

    return {
      ...product,

      price,
      offer_price,
      qty,
      sku,
    };
  };

  // ==================================================
  // NORMALIZE SECTIONS
  // ==================================================

  const normalizedSections =
    sections.map((section) => ({
      ...section,

      products: Array.isArray(
        section.products
      )
        ? section.products.map(
            normalizeProduct
          )
        : [],
    }));

  // ==================================================
  // SORT SECTIONS
  // ==================================================

  const sortedSections = [
    ...normalizedSections,
  ].sort(
    (a, b) =>
      Number(a.sort_order || 0) -
      Number(b.sort_order || 0)
  );

  const firstSection =
    sortedSections[0];

  const remainingSections =
    sortedSections.slice(1);

  // ==================================================
  // OTHER PRODUCT SECTIONS
  // ==================================================

  const filteredNewArrivals =
    new_arrivals
      .map(normalizeProduct)
      .filter(
        (product) =>
          product.qty > 0
      );

  const filteredTrendingProducts =
    trending_products
      .map(normalizeProduct)
      .filter(
        (product) =>
          product.qty > 0
      );

  const filteredTopOffers =
    top_offers
      .map(normalizeProduct)
      .filter(
        (product) =>
          product.qty > 0
      );

  // ==================================================
  // POPUP
  // ==================================================

  useEffect(() => {
    setShowPopup(true);
  }, []);

  return (
    <>
      {/* HOME POPUP */}

      {/* <HomeImagePopup
        isOpen={showPopup}
        onClose={() =>
          setShowPopup(false)
        }
      /> */}

      {/* ==================================================
          BANNERS
      ================================================== */}

      <ThumbnailSlider
        bannersData={banners}
      />

      {/* ==================================================
          CATEGORIES
      ================================================== */}

      <Collections
        categories={categories}
      />
<Recommendations
  wishItems={wishItems}
  isWishListPending={isPending}
/>

   <PromotionalBanner />
      {/* ==================================================
          FIRST HOME SECTION
      ================================================== */}

      {firstSection && (
        <div
          className={
            styles.homeproduct__wrapper
          }
        >
          <Products
            key={firstSection.id}
            title={firstSection.name}
            products={firstSection.products.filter(
              (product) =>
                product.qty > 0
            )}
            wishItems={wishItems}
            isWishListPending={
              isPending
            }
            variant="slider"
          />
        </div>
      )}

      {/* ==================================================
          PROMOTIONAL BANNER
      ================================================== */}

   

      {/* ==================================================
          REMAINING HOME SECTIONS
      ================================================== */}

      <div
        className={
          styles.homeproduct__wrapper
        }
      >
        {remainingSections.map(
          (section) => {
            const filteredProducts =
              section.products.filter(
                (product) =>
                  product.qty > 0
              );

            return (
              <Products
                key={section.id}
                title={section.name}
                products={
                  filteredProducts
                }
                wishItems={
                  wishItems
                }
                isWishListPending={
                  isPending
                }
                variant="slider"
              />
            );
          }
        )}
      </div>

      {/* ==================================================
          BRANDS
      ================================================== */}

      {/* <BrandSlider />  */}

      {/* ==================================================
          TESTIMONIALS
      ================================================== */}

      {/* <Testimonial />  */}

      {/* ==================================================
          BLOGS
      ================================================== */}

      {/* <Blogs />  */}

      {/* ==================================================
          PRODUCT POPUP
      ================================================== */}

      <ProductPopup
        products={
          firstSection?.products?.filter(
            (product) =>
              Number(product.qty) > 0
          ) || []
        }
      />
    </>
  );
};

export default Home;